var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.1 22",
    style: {
      enableBackground: "new 0 0 27.1 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,5.5c0,0.2,0,0.5,0,0.7c0.1,8.7-6.9,15.7-15.6,15.8c-0.1,0-0.1,0-0.2,0l0,0c-3,0-6-0.9-8.5-2.5 c0.4,0.1,0.9,0.1,1.3,0.1c2.5,0,4.9-0.8,6.9-2.4c-2.4,0-4.5-1.6-5.2-3.9c0.8,0.2,1.7,0.1,2.5-0.1C3,12.7,1.1,10.4,1.1,7.8V7.7 c0.8,0.4,1.6,0.7,2.5,0.7C1.2,6.8,0.4,3.6,1.9,1c2.8,3.5,7,5.6,11.4,5.8c-0.7-3,1.2-6,4.2-6.7c1.9-0.4,4,0.2,5.3,1.6 C24,1.5,25.2,1,26.3,0.4c-0.4,1.3-1.3,2.4-2.4,3.1C25,3.3,26.1,3,27.1,2.6C26.3,3.7,25.4,4.7,24.3,5.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWh);
export default __webpack_public_path__ + "static/media/twitter_wh.98f676574f96eaf94261fcd807782132.svg";
export { ForwardRef as ReactComponent };